
import React from 'react';
import { DisplaySlide } from '../layout/DisplaySlide';
import { ContentSection } from '../layout/ContentSection';
import { SectionGrid } from '../layout/SectionGrid';
import { AdaptiveText } from '../layout/AdaptiveText';

interface YahrzeitEntry {
  name: string;
  father_name?: string | null;
  date?: string;
}

interface YahrzeitSlideProps {
  entries: YahrzeitEntry[];
  title?: string;
}

export const YahrzeitSlide: React.FC<YahrzeitSlideProps> = ({
  entries,
  title = "לעילוי נשמת"
}) => {
  return (
    <DisplaySlide background="gradient" padding="md">
      <div className="h-full flex flex-col space-y-6">
        {/* Slide Title */}
        <div className="text-center">
          <AdaptiveText baseSize="xl" className="font-frank font-bold text-white text-shadow-lg">
            {title}
          </AdaptiveText>
        </div>

        {/* Yahrzeit Entries */}
        <SectionGrid 
          columns={entries.length > 4 ? 2 : 1} 
          gap="md" 
          className="flex-1"
        >
          {entries.slice(0, 6).map((entry, index) => (
            <ContentSection
              key={index}
              height="fixed"
              textSize="md"
              className="border-blue-300/50 bg-blue-100/10"
            >
              <div className="text-center space-y-2">
                <AdaptiveText baseSize="lg" className="font-frank font-bold text-blue-200">
                  {entry.name}
                </AdaptiveText>
                {entry.father_name && (
                  <AdaptiveText baseSize="md" className="font-heebo text-blue-100">
                    בן {entry.father_name}
                  </AdaptiveText>
                )}
                {entry.date && (
                  <AdaptiveText baseSize="sm" className="font-heebo text-blue-100/80">
                    {entry.date}
                  </AdaptiveText>
                )}
              </div>
            </ContentSection>
          ))}
        </SectionGrid>
      </div>
    </DisplaySlide>
  );
};
